/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class MainService {
  async getCaptcha(state, type = 'default', refresh = false) {
    const response = await api.get('/main/captcha', { type, refresh });
    const data = await response.json();
    return data;
  }
}

export default new MainService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/services/MainService/MainService.js